"use client";

import dynamic from "next/dynamic";
import { useAppContext } from "@/contexts/app";
import { isAuthEnabled } from "@/lib/auth";
import { ReactElement } from "react";
import { Loader2 } from "lucide-react";

const SignModal = dynamic(() => import("./modal"), {
  ssr: false,
  loading: () => (
    <div className="pointer-events-none fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
      <Loader2 className="h-8 w-8 animate-spin text-white" />
    </div>
  ),
});

export default function SignModalPortal() {
  const { showSignModal } = useAppContext();

  if (!isAuthEnabled() || !showSignModal) {
    return null;
  }

  return <SignModal />;
}
